const toggleMobileNav = () => {
	const toggle = document.querySelector('#toggle-mobile-nav');
	const mobileNav = document.querySelector('.mobile-nav');
	const logo = document.querySelector('.header__logo');
	
	if (toggle && mobileNav) {
		toggle.addEventListener('click', () => {
			toggle.classList.toggle('is-active');
			mobileNav.classList.toggle('mobile-nav--active');
			logo.classList.toggle('header__logo--white');
		});
	}
}

export default toggleMobileNav;
